import { useState } from "react";
import Trans from "features/translation/components/Trans";
import Dialog from "components/ui/Dialog/Dialog";
import Button from "components/ui/Button/Button";
import Input from "components/form/Input/Input";
import useData from "hooks/useData";
import { useDialog } from "context/DialogContext";
import LoginDialog from "features/authentication/components/LoginDialog";

const RequestPasswordReset = ({ title, backButton = true, createAccount = false }) => {
  const { showDialog, hideDialog } = useDialog();
  const [done, setDone] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [email, setEmail] = useState('');
  const { getData } = useData();

  const handleSend = () => {

    const sendResetLink = async () => {
      setError(null);
      setLoading(true);
      const { response } = await getData(
        'rest/stb/password',
        `email=${ email }&action=${ createAccount ? 'create' : 'reset' }`
      );

      if (response?.status === 200) {
        setDone(true);
      } else {
        setError('Er ging iets mis bij het versturen van de link. Probeer het opnieuw of neem contact op met de ledenservice als dit probleem blijft bestaan.');
      }
      setLoading(false);
    }

    if (!email) {
      setError('U heeft nog geen e-mailadres ingevuld.');
      return;
    }

    if (!email.trim().match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/i)) {
      setError('Het opgegeven e-mailadres is ongeldig.')
      return;
    }

    sendResetLink();
  }

  let content;
  if (done) {
    content = (
      <>
        <p>Indien uw e-mailadres bekend is bij ons, krijgt u binnen enkele minuten een e-mail met verdere instructies. </p>
        <p>Heeft u geen e-mail gehad? Neem dan even contact met ons op.</p>
        <div className="dialog__buttons">
          <Button variant={ `secondary` }
                  onClick={ () => hideDialog() }>Sluiten</Button>
        </div>
      </>
    )
  } else {
    content = (
      <>
        <p>
          <Trans
            text="Vul hieronder het e-mailadres in dat bekend is bij ANBO-PCOB. We versturen de verdere instructies naar dit e-mailadres."/>
        </p>
        <div className={ `dialog__row` }>
          <Input
            type={ `text` }
            onChange={ event => setEmail(event.target.value) }
            value={ email }
            placeholder={ `Uw e-mailadres` }
          />
        </div>
        <div className="dialog__buttons">
          <Button variant={ `primary` } onClick={ () => backButton ? showDialog(
            <LoginDialog/>) : hideDialog() }>{ backButton ? `Terug` : `Sluiten` }</Button>
          <Button variant={ `secondary` } onClick={ handleSend }>Versturen</Button>
        </div>
      </>
    )
  }

  return (
    <Dialog
      title={ title }
      loading={ loading }
      errorMessage={ error }>
      { content }
    </Dialog>
  )
}

export default RequestPasswordReset;
